import afterhoursComponent from './afterhours.component';

const afterhoursModule = angular
  .module('afterhours', [])
  .component('afterhours', afterhoursComponent);

export default afterhoursModule;



/** WEBPACK FOOTER **
 ** ./frontend/components/booking/afterhours/afterhours.js
 **/